import React from 'react'
import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'

import { COMMENT_TYPES } from 'types/comments'

import { Thread } from 'services/apiTypes/comment.types'

import { encodeUsernameRoute } from 'utils/encoding'

import styles from './threadListItem.module.scss'

type Props = {
  thread: Thread
}

/**
 * List item for the forum. Displays a single forum post as a "row"
 */
const ThreadListItem = ({ thread }: Props) => {
  const updated = new Date(thread.recentPost.createdAt).toLocaleDateString('en-us', { month: 'short', day: 'numeric' })

  return (
    <div className={styles.container}>
      <div className={styles.iconSpacer}>
        {thread.type === COMMENT_TYPES.Global && <Icon size="big" name="globe" title="Global Thread" />}
        {thread.type === COMMENT_TYPES.Sticky && <Icon size="big" name="sticky note" title="Sticky Thread" />}
        {thread.archived && <Icon size="big" name="archive" color="grey" title="Archived" />}
      </div>

      <div className={styles.threadInfo}>
        <Link className={styles.title} href={`/forum/thread/${thread.id}`}>
          {thread.title}
        </Link>
        <Link href={`/u/${encodeUsernameRoute(thread.owner.username)}`}>{thread.owner.username}</Link>

        {/* Hidden on large screens */}
        <div className={styles.smallNumbers}>
          <span>{thread.childrenCount} responses</span>
          <span>{thread.points} points</span>
        </div>
      </div>

      {/* Numbers are hidden on small screens */}
      <div className={styles.numbers}>
        <span>{thread.childrenCount}</span>
        <span>responses</span>
      </div>

      <div className={styles.numbers}>
        <span>{thread.points}</span>
        <span>points</span>
      </div>

      <div className={styles.recentInfo}>
        <img height={30} src={thread.recentPost.owner.avatar} alt={`${thread.recentPost.owner.username} Avatar`} />

        <div className={styles.wrapBlock}>
          <Link className={styles.user} href={`/u/${encodeUsernameRoute(thread.recentPost.owner.username)}`}>
            {thread.recentPost.owner.username}
          </Link>
          <div>{updated}</div>
        </div>
      </div>
    </div>
  )
}

export default ThreadListItem
